module.exports = __webpack_public_path__ + "img/generalBLE.a72ce49e.png";